module.exports = __webpack_public_path__ + "static/media/DFHaiBao.4f917425.svg";